import { Table as CoreUITable, type TableProps as CoreUITableProps } from '@eleo-rh/core-ui'
import type { TableProps as AntdTableProps } from 'antd'
import { Table as AntdTable } from 'antd'
import type { AnyObject } from 'antd/es/_util/type'

type TableProps<T extends AnyObject = AnyObject> = AntdTableProps<T>

const Table = <T extends AnyObject = AnyObject>(props: TableProps<T>) => {
  const styles: TableProps<T>['styles'] = {
    title: { paddingInline: 0 },
    body: {
      cell: {
        fontSize: 12,
      },
    },
  }

  return <CoreUITable styles={styles} size="small" {...(props as CoreUITableProps)} />
}
Table.EXPAND_COLUMN = AntdTable.EXPAND_COLUMN

export default Table
